import { render, staticRenderFns } from "./wxchronicheader.vue?vue&type=template&id=70a346ee&scoped=true&"
import script from "./wxchronicheader.vue?vue&type=script&lang=js&"
export * from "./wxchronicheader.vue?vue&type=script&lang=js&"
import style0 from "./wxchronicheader.vue?vue&type=style&index=0&id=70a346ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a346ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a346ee')) {
      api.createRecord('70a346ee', component.options)
    } else {
      api.reload('70a346ee', component.options)
    }
    module.hot.accept("./wxchronicheader.vue?vue&type=template&id=70a346ee&scoped=true&", function () {
      api.rerender('70a346ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxchronicheader.vue"
export default component.exports